import { UserStatusEnum } from '../../lib/types/enums/users/user-status.enum'
import { User } from '../../lib/types/models/users/user'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

const statusEndpoints = {
  [UserStatusEnum.ACTIVE]: API.user.activate.url,
  [UserStatusEnum.INACTIVE]: API.user.deactivate.url,
  [UserStatusEnum.BLOCKED]: API.user.block.url
} as const satisfies Record<UserStatusEnum, string>

export function updateUserStatus({ id, status }: { id: number; status: UserStatusEnum }) {
  return restApiClient.url(constructApiUrl(statusEndpoints[status], { id })).post<User>()
}
